/**
 * @generated SignedSource<<30bf316dcdd33ef0559059a6f8a9285e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetHasAccessQuery$data = {
  readonly highlightQueue: {
    readonly settings: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetDailyPulseQuery" | "plusWidgetHighlightsQuery" | "plusWidgetNewsAgendaQuery">;
  readonly " $fragmentType": "plusWidgetHasAccessQuery";
};
export type plusWidgetHasAccessQuery$key = {
  readonly " $data"?: plusWidgetHasAccessQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetHasAccessQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetHasAccessQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuId",
          "variableName": "dailyPulseTypeUuId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetDailyPulseQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "queueName",
          "variableName": "highlightQueueName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetHighlightsQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaEndDate",
          "variableName": "plusNewsAgendaEndDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaStartDate",
          "variableName": "plusNewsAgendaStartDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaTypes",
          "variableName": "plusNewsAgendaTypes"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetNewsAgendaQuery"
    },
    {
      "alias": "highlightQueue",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "name",
              "variableName": "highlightQueueName"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "settings",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "74a8194d39a8ef818cf248a6ec1c15cf";

export default node;
